function eventIsClosed(event: any, baseISO: string): boolean {
  return baseISO > event.endAt
}

export function selectIfConflicts(
  entries: any[],
  baseISO: string,
  beginAtISO: string,
  endAtISO: string
): any[] {
  return entries.filter((entry) => {
    return (
      !eventIsClosed(entry.event, baseISO) &&
      entry.event.beginAt < endAtISO &&
      entry.event.endAt > beginAtISO
    )
  })
}
